// extracted by mini-css-extract-plugin
export var svgBlack = "cl_jR";
export var svgInverted = "cl_kk";
export var svgReviewsIOLogo = "cl_kj";
export var svgWhite = "cl_jQ";